import GridLoader from '@components/Loaders/GridLoader';
import useNotifier from 'hooks/useNotifier';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { LegacyModelContext as Context } from '../context/LegacyModelContext';
import { legacyRoutes } from '../constants';
import LegacyAddItem from '../components/LegacyAddItem';
import { IProductModel as ItemType } from '../types';
import * as actions from '../redux/actions';

const AddItemContainer = () => {
  const notify = useNotifier();
  const history = useNavigate();

  const { getItems, loading } = React.useContext(Context);

  const handleSubmit = (createItemInput: ItemType) => {
    actions.LegacyActions.createLegacyRequest({
      ...createItemInput,
    }).then(async (res) => {
      notify({
        status: 'success',
        text: `Created successfully.`,
      });
      getItems();
      history(legacyRoutes.list);
    });
  };

  if (loading) return <GridLoader />;

  return (
    <LegacyAddItem
      initialValues={{
        productModelID: '',
        productModelName: '',
        productFamilyID: '',
        productModelDescription: '',
        productVendor: 'OVES',
        quantityInStock: 0,
        productModelCost: 0.00,
        image: '',
      }}
      handleSubmit={handleSubmit}
      isLoading={loading}
    />
  );
};

export default AddItemContainer;
